<ion-content
  ><cloudia-cookie-settings [isModal]="true"></cloudia-cookie-settings
></ion-content>
